var React = require('react');

function GrowthLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M46.161 10.75a1 1 0 01.089 1.412L32.568 27.674a3.076 3.076 0 01-4.237.326l-.007-.006-8.924-7.436a1.084 1.084 0 00-1.484.11L3.247 37.165a1 1 0 01-1.494-1.328L16.43 19.329a3.084 3.084 0 014.238-.317l.007.006 8.924 7.436a1.076 1.076 0 001.477-.113l.003-.003 13.67-15.5a1 1 0 011.411-.088z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M30.624 11.5a1 1 0 011-1H45.5a1 1 0 011 1v11.958a1 1 0 11-2 0V12.5H31.624a1 1 0 01-1-1z","key":1})]);
}

GrowthLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = GrowthLight;

GrowthLight.default = GrowthLight;
